<template>
    <footer>
        <div class="inner">
            <div class="logo">
                <img src="@/assets/logo_f.svg" alt="">
                <p>에너지 효율화와 제로에너지 빌딩 기술을 기반으로 지속 가능한 미래 에너지 생태계를 만들어갑니다.</p>
            </div>

            <div class="info">
                <div class="box">
                    <h4>Address</h4>
                    <p>
                        본점 : 전남 나주시 그린로 370 420호 (에너지밸리기업개발원)<br>
                        서울지사 : 서울 마포구 양화로 120 3층<br>
                        부산지사 : 부산 남구 전포대로 133 IFC 11층 103호
                    </p>
                </div>
                <div class="box">
                    <h4>Contact</h4>
                    <p>E-mail : <span class="highlight">energynet@energynet.co.kr</span><br>Blog : <span class="highlight">https://blog.naver.com/energynet0709</span></p>
                </div>
                <div class="box">
                    <h4>Online</h4>
                    <p><a target="_blank" href="https://blog.naver.com/energynet0709" class="nblog-link"><img src="@/assets/nblog.png" alt="네이버 블로그" class="nblog-icon">네이버블로그</a></p>
                </div>
            </div>

            <div  class="script">
                <a href="https://sectigo.com/trust-seal" style="font-family: arial; font-size: 10px; color: #212121; text-decoration: none;"><img src="https://sectigo.com/images/seals/sectigo_trust_seal_sm.png" srcset="https://sectigo.com/images/seals/sectigo_trust_seal_sm.png, https://sectigo.com/images/seals/sectigo_trust_seal_sm_2x.png 2x" width="82" height="32" alt="Protected by Sectigo SSL" border="0" /></a><div style="font-family: arial;font-weight:bold;font-size:15px;color:#86BEE0;"><a href="https://sectigo.com" style="color:#86BEE0; text-decoration: none;">SSL Certificate</a></div> 
            </div>
            
        </div>
        <div class="bott">
            <span>2025 EnergyNet Co., Ltd. All Rights Reserved.</span>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "TheFooter",
    }
</script>